export default __webpack_public_path__ + "web/images/exit_account.svg";